import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { settingsService } from '@features/settings/setting-services/setting-service';
import { ToastService } from '@core/services/toast.service';
import { ModalService } from '@shared/services/modal.service';
import { CommonDropdownComponent } from '@shared/components/common-dropdown/common-dropdown.component';

const STATUS_OPTIONS = ['Active', 'Inactive'];

@Component({
  selector: 'app-user-status-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CommonDropdownComponent],
  template: `
    <div class="user-status-modal">
      <div class="user-status-modal__header">
        <div class="status-icon">
          <span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="50" height="50" rx="25" fill="#F0F0F0"/>
<path d="M24.9999 26.2C17.8959 26.2 15.3999 29.8 15.3999 32.2V35.8H34.5999V32.2C34.5999 29.8 32.1039 26.2 24.9999 26.2Z" fill="#30008E"/>
<path d="M25.0001 25C27.9824 25 30.4001 22.5824 30.4001 19.6C30.4001 16.6177 27.9824 14.2 25.0001 14.2C22.0178 14.2 19.6001 16.6177 19.6001 19.6C19.6001 22.5824 22.0178 25 25.0001 25Z" fill="#30008E"/>
</svg>
</span>
        </div>
        <h2 class='text-[14px] font-[400]'>Update User Status</h2>
        <p class='text-[14px] font-[300] text-center'>Are you sure you want to change the user’s account status?</p>
      </div>

      <form [formGroup]="statusForm" class="user-status-modal__body">
        <label class="label" for="status">Status</label>
        <app-common-dropdown
          [items]="statusOptions"
          [placeholder]="'Select Status'"
          [selectedItem]="currentStatus"
          [width]="'100%'"
          [useFixedPosition]="false"
          (itemSelected)="setStatus($event)"
        ></app-common-dropdown>
      </form>

      <div class="user-status-modal__footer">
        <button
          type="button"
          class="status-footer-button cancel"
          [disabled]="isSubmitting"
          (click)="handleCancel()"
        >
          Cancel
        </button>

        <button
          type="button"
          class="status-footer-button confirm  button-color text-white rounded "
          [disabled]="statusForm.invalid || isSubmitting"
          (click)="handleConfirm()"
        >
          Confirm
        </button>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .user-status-modal {

    }

    .user-status-modal__header {
      text-align: center;
      display: flex;
      flex-direction: column;
      gap: 24px;
      align-items: center;
    }

    .status-icon {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: #fefefe;
      display: grid;
      place-items: center;
      border: 1px solid rgba(17, 24, 39, 0.08);
      font-size: 32px;
    }

    .user-status-modal__header h2 {
      margin: 0;
      font-size: 22px;
      font-weight: 500;
    }

    .user-status-modal__header p {
      margin: 0;
      font-size: 14px;
      color: var(--colors-text-secondary, #6b7280);
    }

    .user-status-modal__body {
      width: 105%;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .label {
      font-size: 14px;
      font-weight: 300;
      margin-top: 16px;
      color: var(--colors-text-secondary, #6b7280);
    }

    app-common-dropdown {
      width: 100%;
    }

    .user-status-modal__footer {
      display: flex;
      gap: 12px;
      // justify-content: flex-end;
    }

    .status-footer-button {
      min-width: 50%;
      height: 44px;
      padding: 12px 24px;
      border-radius: 10px;
      font-family: 'Lexend', sans-serif;
      font-weight: 500;
      font-size: 14px;
      margin-top: 24px;
      border: 1px solid transparent;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: transform 0.2s ease, opacity 0.2s ease;
      text-transform: none;
      gap: 6px;
    }

    .status-footer-button.cancel {
      background: var(--colors-background-button-alt, #f5f5f5);
      border-color: rgba(15, 23, 42, 0.08);
      color: var(--colors-text-secondary, #6b7280);
    }

    .status-footer-button.confirm {
      color: #ffffff;
    }

    .status-footer-button.confirm:not(:disabled) {
      // box-shadow: 0 4px 18px rgba(17, 24, 39, 0.25);
    }

    .status-submit-btn {
      min-width: 110px;
      height: 44px;
      padding: 0 24px;
      border-radius: 10px;
    }

    .status-submit-btn.button-color {
      background: radial-gradient(38.61% 40.02% at 50.15% 0%, #505050 0%, #121212 100%) !important;
    }

    .status-submit-btn.button-color:not(:disabled) {
      box-shadow: 0 4px 18px rgba(17, 24, 39, 0.25);
    }

    .status-footer-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    :host-context(.dark) .status-footer-button.cancel,
    :host-context([data-theme='dark']) .status-footer-button.cancel {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.12);
      color: #e5e7eb;
    }

    :host-context(.dark) .user-status-modal,
    :host-context([data-theme='dark']) .user-status-modal {


      color: #f8fafc;
    }

    :host-context(.dark) .status-icon,
    :host-context([data-theme='dark']) .status-icon {
      background: rgba(255, 255, 255, 0.05);
      border-color: rgba(255, 255, 255, 0.1);
    }

    :host-context(.dark) app-common-dropdown {
      --dropdown-trigger-bg: #0f172a;
    }

  `],
})
export class UserStatusModalComponent implements OnChanges {
  @Input() user?: any;
  @Input() onStatusUpdated?: (status: string) => void;
  @Output() statusUpdated = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  statusOptions = STATUS_OPTIONS;
  statusForm: FormGroup;
  isSubmitting = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly settingsService: settingsService,
    private readonly toastService: ToastService,
    private readonly modalService: ModalService,
  ) {
    this.statusForm = this.fb.group({
      status: ['Active', [Validators.required]],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['user'] && this.user) {
      const currentStatus = this.normalizeStatusLabel(this.user.status?.StatusCode);
      this.statusForm.get('status')?.setValue(currentStatus);
    }
  }

  get currentStatus(): string {
    const rawValue = this.statusForm.get('status')?.value;
    return this.normalizeStatusLabel(rawValue);
  }

  setStatus(value: string): void {
    this.statusForm.get('status')?.setValue(this.normalizeStatusLabel(value));
  }

  private normalizeStatusLabel(value: unknown): 'Active' | 'Inactive' {
    return this.tryParseStatusLabel(value) ?? 'Active';
  }

  private tryParseStatusLabel(value: unknown): 'Active' | 'Inactive' | null {
    if (value === null || value === undefined) {
      return null;
    }

    const normalized = String(value).trim().toLowerCase();

    if (['inactive', '2', 'false', 'locked'].includes(normalized)) {
      return 'Inactive';
    }

    if (['active', '1', 'true', 'unlocked'].includes(normalized)) {
      return 'Active';
    }

    return null;
  }

  private statusCodeFromLabel(label: string): 0 | 1 {
    return this.normalizeStatusLabel(label) === 'Inactive' ? 0 : 1;
  }

  private statusLabelFromResponse(response: any): string | null {
    const candidates = [
      response?.data?.status?.StatusCode,
      response?.data?.status?.Status,
      response?.data?.StatusCode,
      response?.data?.Status,
      response?.status,
      response?.Status,
    ];

    for (const candidate of candidates) {
      const normalized = this.tryParseStatusLabel(candidate);
      if (normalized) {
        return normalized;
      }
    }

    return null;
  }

  handleCancel(): void {
    this.cancelled.emit();
  }

  handleConfirm(): void {
    if (this.statusForm.invalid || this.isSubmitting || !this.user) return;

    const selectedStatus = this.currentStatus;
    const userId = this.user.id || this.user.UserID;

    if (!userId) {
      this.toastService.error('Error', 'Unable to resolve the user for status update');
      return;
    }

    const payload = {
      name: this.user.name || this.user.fullName || '',
      email: this.user.email || '',
      userName: this.user.userName || this.user.UserName || '',
      status_id: this.statusCodeFromLabel(selectedStatus),
      status: selectedStatus,
      agentId: userId,
    };

    this.isSubmitting = true;

    this.settingsService.updateUser(payload).subscribe({
      next: response => {
        const finalStatus = this.statusLabelFromResponse(response) || selectedStatus;
        this.toastService.success('Success', `User status updated to ${finalStatus}`);
        this.onStatusUpdated?.(finalStatus);
        this.statusUpdated.emit(finalStatus);
        this.isSubmitting = false;
        this.modalService.closeModal('user-status-modal');
      },
      error: (error: any) => {
        this.toastService.error('Error', error?.error?.message || 'Failed to update status');
        this.isSubmitting = false;
      },
    });
  }
}
